import { CurrencyPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calioCurrency',
  standalone: true,
})
export class CalioCurrencyPipe implements PipeTransform {

  private currencyPipe = inject(CurrencyPipe);

  transform(value: string | number, currencyCode = 'CHF', locale: string): any {
    const numValue = this.parseValue(value);
    const upperCurrency = currencyCode.toUpperCase();

    // Handle specific currency formats
    switch (upperCurrency) {
      case 'GBP':
        return `£${this.formatNumber(numValue, ',', '.')}`;
      case 'EUR':
        return `${this.formatNumber(numValue, '.', ',')} €`;
      case 'USD':
      case 'AUD':
      case 'NZD':
        return `$${this.formatNumber(numValue, ',', '.')}`;
      case 'CHF':
        return `CHF ${this.formatNumber(numValue, "'", '.')}`;
      default:
        return this.formatDefault(numValue, upperCurrency, locale);
    }
  }

  private formatDefault(value: number, currencyCode: string, locale: string): string {
    const usedLocale = locale?.split('_')[0] || 'ch';

    const rawValue = this.currencyPipe.transform(
      value,
      currencyCode,
      'symbol',
      '1.2-2',
      usedLocale
    );
    // Insert space after currency code for en-US only
    if (usedLocale === 'en' && rawValue?.startsWith(currencyCode)) {
      return rawValue.replace(currencyCode, `${currencyCode} `);
    }

    return rawValue || '';
  }

  private parseValue(value: string | number): number {
    if (typeof value === 'number') {
      return value;
    } else if (typeof value === 'string') {
      // Remove any existing formatting and parse
      const cleaned = value.replace(/[^\d.-]/g, '');
      return parseFloat(cleaned) || 0;
    }
    return 0;
  }

  private formatNumber(value: number, thousandSeparator: string, decimalSeparator: string): string {
    // Round to exactly 2 decimal places
    const rounded = Math.round(value * 100) / 100;
    const valueStr = rounded.toFixed(2);
    const [integerPart, decimalPart] = valueStr.split('.');

    // Format integer part with thousand separator using regex
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

    // Always append decimal part (exactly 2 decimals)
    return `${formattedInteger}${decimalSeparator}${decimalPart}`;
  }
}
